import { createGlobalStyle } from "styled-components";
import { primaryColor } from "../config";

const GlobalStyles = createGlobalStyle`
  :root {
    --app-bg: #F1F2F4;
    --app-surface: #FFFFFF;
    --app-surface-alt: #F9F9F9;
    --app-text: #181C32;
    --app-text-muted: #6B7280;
    --app-border: #E4E6EF;
    --app-border-soft: #EFF2F5;
  }

  [data-bs-theme=dark] {
    --app-bg: #151521;
    --app-surface: #1E1E2D;
    --app-surface-alt: #2B2B40;
    --app-text: #E1E3EA;
    --app-text-muted: #A1A5B7;
    --app-border: #2B2B40;
    --app-border-soft: #323248;
  }

  body{
    background-color: var(--app-bg) !important;
    color: var(--app-text) !important;
  }

  /* Auth routes always use fixed light styling — ignore saved dark mode */
  html.auth-theme-locked body,
  html.auth-theme-locked .app-default {
    background-color: #263d57 !important;
    color: #181c32 !important;
  }

.app-default, body {
    background-color: var(--app-bg) !important;
}
    [data-kt-app-sidebar-minimize=on] .app-sidebar-toggle .rotate-180{transform: rotateZ(180deg);   transition: transform .3s ease;}
.ant-breadcrumb ol{align-items:center}

.cus-table .ant-table-thead tr th {
    background-color: #F0ECF9 !important;
    color: #181C32 !important;
    font-weight: 700 !important;
}

[data-bs-theme=dark] .cus-table .ant-table-thead tr th {
    background-color: var(--bs-dark-bg-subtle) !important;
    color: var(--bs-dark-text) !important;
    font-weight: 700 !important;
}
.ant-table {
    font-size: 13px !important;
}
.ant-pagination .ant-pagination-item-active {
    font-weight: 600;
    background-color: #f45b68;
    border-color: #f45b68;
}
  .ant-pagination .ant-pagination-item-active a{color:#fff !important}
        .ant-pagination .ant-pagination-options {
          margin-left: auto;

          .ant-select-selector {
            border: 1px solid var(--app-border) !important;
            background: var(--app-surface-alt) !important;
            color: var(--app-text);
          }

          .ant-select-selection-item {
            font-size: 13px;
            font-weight: 500;
            font-family: Inter;
            color: var(--app-text) !important;
          }

          .ant-select-arrow {
            color: var(--app-text-muted);
          }
        }
  }

  .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    color: var(--app-text);
    font-weight: 600;
    background-color: #f45b6814;
}

[data-bs-theme=dark] .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    color: var(--app-text);
    background-color: rgba(244, 91, 104, 0.2);
}
 .ant-dropdown-menu-title-content{display:flex;align-items:center}
 .ant-breadcrumb ol{align-items: center !importnant;}
.ant-table-wrapper .ant-table-tbody >tr >th, .ant-table-wrapper .ant-table-tbody >tr >td {
    border-bottom: 1px dashed #ebe5e5;
}
.ant-modal .ant-modal-content {
  padding: 0;
  background: var(--app-surface) !important;
  color: var(--app-text);
}

.ant-modal .ant-modal-header {
  padding: 1.75rem 1.75rem;
  margin-bottom: 0;
  border-bottom: 1px dashed var(--app-border);
  background: var(--app-surface) !important;
}

.ant-modal .ant-modal-title {
  color: var(--app-text) !important;
}

.ant-modal .ant-modal-body {
  padding: 1.75rem 1.75rem;
  background: var(--app-surface);
  color: var(--app-text);
}

.ant-modal .ant-modal-footer {
  padding: 1rem 1.75rem;
  border-top: 1px dashed var(--app-border);
  margin-top: 0;
  background: var(--app-surface) !important;
}

.ant-modal .ant-modal-close {
  color: var(--app-text-muted);
}

.ant-modal .ant-modal-close:hover {
  color: var(--app-text);
}

.ant-table-wrapper .ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {
    box-shadow: none;
}
.ant-table-wrapper .ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container::after {
    box-shadow: none;
}

  .custom-logout-modal .ant-modal-content {
      border-radius: 8px;
      padding: 24px;
      animation: fadeInUp 0.8s ease;
      box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  }

  .custom-logout-modal .ant-modal-header {
      border-bottom: none;
  }

  .custom-logout-modal .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
  }

  .custom-logout-modal .ant-btn-primary {
      background-color: #f45b68;
      border-color: #f45b68;
      font-weight: 600;
  }

  .custom-logout-modal .ant-btn-default {
      font-weight: 500;
      color: #666;
  }

  /* Optional fadeIn animation */
  @keyframes fadeInUp {
      from {
          opacity: 0;
          transform: translateY(40px);
      }
      to {
          opacity: 1;
          transform: translateY(0);
      }
  }

  .ant-carousel .slick-prev::after,
  .ant-carousel .slick-next::after,
  .ant-carousel .slick-prev::before,
  .ant-carousel .slick-next::before {
      display: none !important;
      content: '' !important;
  }
.ant-switch .ant-switch-handle {
    top: 4px;
    inset-inline-start: 4px;
}

.ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title, .ant-menu-light>.ant-menu .ant-menu-submenu-selected >.ant-menu-submenu-title {
    color: #232323;
}

[data-bs-theme=dark] .ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title,
[data-bs-theme=dark] .ant-menu-light > .ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: var(--app-text);
}

[data-bs-theme=dark] .ant-modal .ant-modal-content .ant-modal-header,
[data-bs-theme=dark] .ant-modal .ant-modal-content .ant-modal-footer {
    border-color: var(--app-border);
}

[data-bs-theme=dark] .ant-table-wrapper .ant-table-tbody > tr > th,
[data-bs-theme=dark] .ant-table-wrapper .ant-table-tbody > tr > td {
    border-bottom-color: var(--app-border);
}

.ant-dropdown {
    z-index: 1000;
}

.ant-btn-color-dangerous.ant-btn-variant-solid {
      color: #fff;
      background: #f45b68;
}

.ant-form-item {
    margin-bottom: 14px;
}

  .ant-segmented {
      padding: 4px;
}

  /*
   * Pendo guide tooltip arrow alignment fix.
   * The app renders inside a zoom: 0.83 root, and the Pendo theme applies
   * an inverse zoom (1.204819) on ._pendo-step-container-size. The arrow
   * sits inside that container and ends up double-scaled, so we cancel
   * the inverse zoom on the arrow elements specifically.
   */
  ._pendo-guide-arrow,
  ._pendo-guide-arrow-border {
      zoom: calc(1 / 1.204819) !important;
      transform-origin: top left !important;
  }

  .estimated-badge-popover .ant-popover-inner {
    background: #1e293b !important;
    border-radius: 8px !important;
    padding: 12px 14px !important;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
    font-family: "Inter", Helvetica, sans-serif !important;
    font-size: 14px !important;
    line-height: 1.5715 !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .estimated-badge-popover .ant-popover-arrow::before,
  .estimated-badge-popover .ant-popover-arrow::after {
    background: #1e293b !important;
  }

  .estimated-badge-popover .ant-popover-inner-content {
    padding: 0 !important;
  }
`;

export default GlobalStyles;
